import sx from 'utils/createSx';
import theme from 'ThemeProvider/theme';

export default sx({
  link: {
    color: theme.palette.text.primary,
    textDecoration: 'none',
  },
});
